<script>
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import constants from "../../constants";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Report Card",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Layout,
    Multiselect,
  },
  data() {
    return {
      title: "Results",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Report Card",
          active: true,
        },
      ],
      terms: [
        { id: 1, name: "Term 1" },
        { id: 2, name: "Term 2" },
        { id: 3, name: "Term 3" },
      ],
      data: {
        quantity: "",
        term: "",
        class: "",
        item: "",
      },
      summitGrades: [],
      sysConstants: constants,
      classError: "",
      itemError: "",
      quantityError: "",
      termError: "",
    };
  },
  watch: {
    SaveStatus(newVal) {
      if (!newVal) {
        this.resetError();
        this.closeModal(this.modal);
      }
    },
  },
  computed: {
    ...mapGetters("classes", ["AllClasses", "AllClassStreams"]),
    ...mapGetters("inventory", ["StoreItems", "AllRequirements", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  mounted() {},
  methods: {
    ...mapActions({
      FetchClasses: "classes/fetchClasses",
      FetchStoreItems: "inventory/fetchStoreItems",
      AddRequirements: "inventory/addRequirements",
      FetchRequirements: "inventory/fetchRequirements",
    }),
    fetchStreamsinClass(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class streams
      this.FetchClassStreams(classSelected);
    },
    submitFilter() {
      this.FetchReportDetails(this.data);
    },
    addBordingRequirements(modal) {
      console.log(this.data);
      if (this.data.class == "") {
        this.classError = "Class Name field can't be empty";
        return;
      } else {
        this.classError = "";
        this.data.type = "boarding";
        this.AddRequirements(this.data);
      }
      this.modal = modal;
      this.AddClass(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },

    resetError() {
      this.data = {
        quantity: "",
        term: "",
        class: "",
        item: "",
      };
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.class = "";
      this.deletedata.id = "";
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchClasses();
    this.FetchStoreItems();
    this.FetchRequirements();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_reports')
        )
      "
    >
      <div class="row d-flex">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <h5 class="">
                  <b>Boarding section</b>
                  <!-- <button
                    v-b-modal.add-class-modal
                    class="btn btn-sm btn-secondary float-end"
                    v-if="
                      getCurrentUser.permissions.find((item) =>
                        item.permission.includes('add_class')
                      )
                    "
                  >
                    <i class="fa fa-plus"></i> Boarding Requirement
                  </button> -->
                  <button
                    v-b-modal.add-reqmtBoarding-modal
                    class="btn btn-sm btn-primary float-end"
                    v-if="
                      getCurrentUser.permissions.find((item) =>
                        item.permission.includes('add_fees_settings')
                      )
                    "
                  >
                    <i class="fa fa-plus"></i> Boarding Requirement
                  </button>
                </h5>
                <hr />
                <p class="text-muted my-2">
                  Below are the requirements for the Boarding section.<br />
                  <b><u>For Term 1 2024</u></b>
                </p>
                <div class="row col-md-12 mt-2">
                  <div class="col-md-6">
                    <h6>
                      <b>Name: </b>Bryan Austin (
                      <b class="text-muted">Left School</b>
                      )
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end card -->
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <h5 class="">
                  <b>Day Section</b>
                  <button
                    class="btn btn-sm btn-secondary float-end"
                    v-if="
                      getCurrentUser.permissions.find((item) =>
                        item.permission.includes('add_class')
                      )
                    "
                  >
                    <i class="fa fa-plus"></i> Day Requirement
                  </button>
                </h5>
                <hr />
                <p class="text-muted my-2">
                  Below are the requirements for the day section.<br />
                  <b><u>For Term 1 2024</u></b>
                </p>
                <div class="row col-md-12 mt-2">
                  <div class="col-md-6">
                    <h6>
                      <b>Name: </b>Bryan Austin (
                      <b class="text-danger">Left School</b>
                      )
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end card -->
        </div>
        <b-modal
          id="add-reqmtBoarding-modal"
          hide-footer
          @hidden="resetAddModal()"
          v-if="
            getCurrentUser.permissions.find((item) =>
              item.permission.includes('add_fees_settings')
            )
          "
        >
          <template #modal-title>Add Requirement for Boarding</template>
          <form
            @submit.prevent="addBordingRequirements('add-reqmtBoarding-modal')"
          >
            <div class="row">
              <div class="form-group mb-2 col-md-6">
                <label class="col-form-label">Select Item</label>
                <select class="form-control" required v-model="data.item">
                  <option value="" selected disabled>Select Item</option>
                  <option
                    v-for="(item, index) in StoreItems"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="form-group mb-2 col-md-6">
                <label class="col-form-label">Quantity</label>
                <div class="input-group">
                  <input
                    required
                    type="number"
                    placeholder="Quantity"
                    class="form-control"
                    v-model="data.quantity"
                  />
                </div>
                <div class="text-danger" v-if="quantityError">
                  <em>{{ quantityError }}</em>
                </div>
              </div>
              <div class="form-group mb-2 col-md-6">
                <label class="col-form-label">Term</label>
                <div class="input-group">
                  <select required class="form-control" v-model="data.term">
                    <option value="" selected disabled>Select Term</option>
                    <option
                      v-for="(t, index) in terms"
                      :key="index"
                      :value="t.id"
                    >
                      {{ t.name }}
                    </option>
                  </select>
                </div>
                <div class="text-danger" v-if="termError">
                  <em>{{ termError }}</em>
                </div>
              </div>
              <div class="form-group mb-2 col-md-6">
                <label class="col-form-label">Classes</label>
                <div class="input-group">
                  <multiselect
                    v-model="data.class"
                    :height="300"
                    :options="AllClasses ? AllClasses : []"
                    :multiple="true"
                    :taggable="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    tag-placeholder="Add a class"
                    placeholder="Search or add a class"
                    label="name"
                    track-by="id"
                    :preselect-first="false"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }"
                      ><span
                        class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} options selected</span
                      ></template
                    >
                  </multiselect>
                </div>
                <div class="text-danger" v-if="classError">
                  <em>{{ classError }}</em>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-sm btn-outline-danger"
                data-dismiss="modal"
                @click="closeModal('add-reqmtBoarding-modal')"
              >
                <i class="fa fa-times"></i> Close
              </button>
              <button type="submit" class="btn btn-sm btn-outline-primary">
                <i class="fa fa-check"></i>
                Submit
                <b-spinner
                  v-if="SaveStatus"
                  variant="light"
                  small
                  label="Spinning"
                ></b-spinner>
              </button>
            </div>
          </form>
        </b-modal>
      </div>
    </div>
    <!-- <div class="breaker"></div> -->
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.bod {
  border: 1px solid gray;
}
.break {
  page-break-after: auto !important;
  page-break-before: always;
}
</style>
